import Vue from 'vue';
import Vuex from 'vuex';

import auth from './modules/auth.module';
import benefit from './modules/benefit.module';
import benefitsUsage from './modules/benefitsUsage.module';
import card from './modules/card.module';
import category from './modules/category.module';
import notification from './modules/notification.module';
import partner from './modules/partner.module';
import place from './modules/place.module';
import profile from './modules/profile.module';
import settings from './modules/settings.module';
import system from './modules/system.module';
import terms from './modules/terms.module';
import application from './modules/application.module';
import collectionPoint from './modules/collectionPoint.module';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    application,
    collectionPoint,
    auth,
    benefit,
    benefitsUsage,
    card,
    category,
    partner,
    notification,
    place,
    profile,
    settings,
    system,
    terms
  }
});
